import * as React from "react";
import { Field } from "formik";
import { TextField } from "formik-mui";
import { TextFieldProps } from "@mui/material";

interface LocalProps {
  name: string;
  validationRegex?: string;
  validationMessage?: string;
}

type Props = LocalProps & TextFieldProps;

const TextInputField: React.FC<Props> = ({
  name,
  label,
  placeholder,
  required,
  disabled,
  helperText,
  multiline,
  rows,
  minRows,
  maxRows,
  type,
  validationRegex,
  validationMessage,
  variant = "standard",
  ...otherProps
}) => {
  const validate = React.useCallback(
    (value: string | number | undefined) => {
      if (required && !value && value !== 0) {
        return "Required";
      }
      if (typeof value === "string" && validationRegex && value && !value.match(new RegExp(validationRegex))) {
        return validationMessage || "Invalid format";
      }
      return undefined;
    },
    [required, validationRegex, validationMessage]
  );
  return (
    <Field
      name={name}
      component={TextField}
      placeholder={placeholder || label}
      label={label}
      variant={variant}
      required={required}
      disabled={disabled}
      type={type}
      multiline={multiline}
      rows={rows}
      minRows={minRows}
      maxRows={maxRows}
      fullWidth
      validate={validate}
      helperText={helperText}
      {...otherProps}
    />
  );
};
export { TextInputField };
